// Klaviyo listener (international customers)
window.addEventListener("klaviyoForms", function(e) {
    if (e.detail.type == 'submit') {
        switch (e.detail.formId) {
            case "RGutgq":
                checkForMysteryItem();
                break;
        }
    }
});

// Postscript listener (US customers)
window.addEventListener("postscriptPopup", function(e) {
    if (e.detail.type === 'subscriberCreated' && 
        e.detail.popupName === 'Dec 19, 2025 | Popup') {
        checkForMysteryItem();
    }
});

var mysteryItemAdding = false; // Flag to prevent duplicate adds

function checkForMysteryItem() {
    // Prevent multiple executions
    if (mysteryItemAdding) {
        console.log('Mystery gift already adding, ignoring duplicate request.');
        return;
    }
    
    mysteryItemAdding = true; // Lock it
    console.log('Mystery gift triggered.');
    
    var variantId = '42303997378751';
    var quantity = 1;
    
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            quantity: quantity,
            id: variantId
        },
        success: function(data) {
            console.log('Product added to cart:', data);
            $.getJSON('/cart.js', function(cart) {
                console.log('Rebuy cart triggered:', cart);
            });
        },
        error: function(error) {
            console.error('Error adding product to cart:', error);
            mysteryItemAdding = false; // Reset on error so they can retry
        }
    });
}